export default {
  services: "Services",
  addServices: "AddServices",
  editServices: "EditServices",
};
